// "use client";
// import { memo } from "react";
// import dynamic from "next/dynamic";
// import PropTypes from "prop-types";

// const PortfolioSlider = dynamic(() => import("./portfolio-slider"), {
//   ssr: false,
//   loading: () => null, // or keep your loader
// });

// const PortfolioSection = memo((props) => {
//   return <PortfolioSlider {...props} />;
// });

// PortfolioSection.propTypes = {
//   className: PropTypes.string,
//   listData: PropTypes.array,
//   loading: PropTypes.bool,
// };

// export default PortfolioSection;

"use client";
import { memo } from "react";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";

const PortfolioSlider = dynamic(() => import("./portfolio-slider"), {
  loading: () => <div className="min-h-[360px] w-full" />, // match slide height (h-[360px] in your slide markup)
});

const PortfolioSection = memo((props) => {
  return <PortfolioSlider {...props} />;
});

PortfolioSection.propTypes = {
  className: PropTypes.string,
  listData: PropTypes.array,
  loading: PropTypes.bool,
};

export default PortfolioSection;
